import React, { useEffect } from 'react';
import { useTitle } from '../../../context/TitleContext';
import { useTranslation } from 'react-i18next';
import "../../../shared/components/Home/home.css";

const DoctorDashboard = () => {
  const { t, i18n } = useTranslation("global");
  const { setTitle } = useTitle();
  
  useEffect(() => {
    setTitle("لوحة التحكم");
  }, [setTitle]);
  
  
  return (
      <div className="main_content">
      <div className="dashboard-container">
        {/* اللوجو */}
        <div className="row mb-5">
          <div className="col-12 text-center">
            <img 
              src="/logokhadamat.png" 
              alt="خدمات منطقتي" 
              style={{
                height: '120px',
                width: 'auto'
              }}
            />
          </div>
        </div>

        </div>
      </div>
  );
};

export default DoctorDashboard;
